import React, { Component } from 'react'
import { Provider } from 'mobx-react'
import { Link } from 'react-router'

export default ({
  store: Store,
  isLocalMerchant = true,
  provideStore = true
} = {}) => WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props)

      this.store = null

      if (Store) {
        try {
          this.store = new Store()
        } catch (e) {}
      }
    }

    componentWillUnmount() {
      this.store = null
    }

    getViewData = () => {
      const viewData = {}

      const route = this.props.routes
        .slice()
        .reverse()
        .find(item => item.moduleName)
      if (route) {
        const { path, moduleName } = route
        const { title } = this.props.route
        viewData.header = [
          isLocalMerchant ? (
            <Link to={`/localMerchant/${path}`}>{moduleName}</Link>
          ) : (
            <Link to={`/${path}`}>{moduleName}</Link>
          ),
          title
        ]
        viewData.title = title
      }

      return viewData
    }

    render() {
      const Comp = (
        <WrappedComponent
          {...this.props}
          store={this.store}
          viewData={this.getViewData()}
        />
      )

      if (provideStore) {
        return <Provider store={this.store}>{Comp}</Provider>
      }
      return Comp
    }
  }
}
